import { useDispatch, useSelector } from 'react-redux'
import { selectTranslations } from '../../services/i18n/i18nSlice'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';

import './Exams.css'
import { fetchExam } from './ExamApi';
import { setLoading } from '../../services/global/globalSlice';
import ConfirmModal from '../../components/_modals/ConfirmModal';
import ExamTable from './_components/ExamTable';
import { Tab, Tabs } from 'react-bootstrap';
import ScoreboardTable from './_components/ScoreboardTable';

export default function UserExamsScreen(props) {

    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [examData, setExamData] = useState({})
    const [isUpdated, setIsUpdated] = useState(false)
    const [confirmModal, setConfirmModal] = useState({
        title: "",
        text: "",
        onClose: null,
        onConfirm: null,
        confirmCta: "",
        closeCta: ""
    })

    const {exam_id} = useParams()

    const prepareExamData = () => {
        const _data = structuredClone(examData)
        if(_data['start_date'])
            _data['start_date'] = `${new Date(_data['start_date']).toISOString().substring(0,19)}+00:00`
        if(_data['end_date'])
            _data['end_date'] = `${new Date(_data['end_date']).toISOString().substring(0,19)}+00:00`
        if(_data['allowed_groups']?.length > 0)
            _data['allowed_groups'] = _data['allowed_groups']?.map(g=>g.group_id)
        if(_data['allowed_users']?.length > 0)
            _data['allowed_users'] = _data['allowed_users']?.map(u=>u.user_id)
        if(_data['time'])
            _data['time'] = parseInt(_data['time'])
        console.log(_data['thresholds']);
        if(_data['thresholds']?.length > 0)
            _data['thresholds'] = _data['thresholds']?.map((t)=>{
                if(t.threshold_name)
                    return {
                        threshold_name: t.threshold_name,
                        score: parseInt(t.score),
                        threshold_type: t.threshold_type
                    }
        })
        return _data
    }

    const loadExamData = async ( ) => {
        let _exam_id = examData.exam_id || exam_id 
        const response =  await fetchExam(_exam_id)
        if(response.success){
            setExamData(response.data)
            dispatch(setLoading(false))
        } else {
            console.error("error")
        }
    }

    useEffect(()=>{
        if(exam_id){
            dispatch(setLoading(true))
            loadExamData()
        } else {
            navigate('/exams',{replace:true})
        }
    },[])

    return (
        <section id="examsScreen">
            {
                examData &&
                <>
                    <h1 className='mb-2'>{examData.title}</h1>
                    <Tabs
                        defaultActiveKey="attempts"
                        id="noanim-tab-example"
                        className="mt-3 mb-4"
                    >
                        <Tab eventKey="attempts" title={t.exam.attempts}>
                            <ExamTable examId={exam_id} />
                            <ConfirmModal props={confirmModal}/>
                        </Tab>
                        <Tab eventKey="scoreboard" title={t.exam.scoreboard}>
                            <ScoreboardTable examId={exam_id} />
                        </Tab>
                        
                    </Tabs>
                    
                </>
            }
            
        </section>
    )
}